import { useState } from 'react';
import { mapClasses } from '../../utils/styles';
import './style.scss';
type maxCount = {
  count: number;
  mode: 'onFocus' | 'on';
};
type Props = {
  disabled?: boolean;
  state?: 'success' | 'error';
  value?: string;
  placeholder?: string;
  onChange?: (value: string) => void;
  onFocus?: () => void;
  autoFocus?: boolean;
  onBlur?: (value: string) => void;
  onKeyDown?: (key: string, value?: string) => void;
  maxCount?: maxCount;
};

export const TextInput = ({
  disabled = false,
  state,
  autoFocus,
  value = '',
  placeholder,
  onChange,
  onFocus,
  onBlur,
  onKeyDown,
  maxCount,
}: Props) => {
  const [inputState, setInputState] = useState({
    count: value?.length,
    focus: false,
  });
  const { count, focus } = inputState;
  const classes = mapClasses({ disabled, state });
  return (
    <>
      <input
        className={`tru-text-input ${classes}`}
        type="text"
        disabled={disabled}
        autoFocus={autoFocus}
        value={value}
        placeholder={placeholder}
        onChange={(event) => {
          if (maxCount && event.currentTarget.value?.length <= maxCount.count)
            onChange?.(event.currentTarget.value);

          if (!maxCount) onChange?.(event.currentTarget.value);

          setInputState({
            ...inputState,
            count: event.currentTarget.value?.length,
          });
        }}
        onFocus={() => {
          onFocus?.();
          setInputState({ ...inputState, focus: true });
        }}
        onBlur={(event) => {
          setInputState({ ...inputState, focus: false });
          onBlur && onBlur(event.currentTarget.value);
        }}
        onKeyDown={(event) =>
          onKeyDown && onKeyDown(event.key, event.currentTarget.value)
        }
      />
      {maxCount &&
        (maxCount.mode === 'on' || (maxCount.mode === 'onFocus' && focus) ? (
          <p className="count-text">
            {maxCount.count - count >= 0 ? maxCount.count - count : 0}{' '}
            Characters left
          </p>
        ) : null)}
    </>
  );
};
